import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { DropTargetOptions, FileItem, HttpClientUploadService } from '@wkoza/ngx-upload';
import {
    verifySizeDownLoad,
    verifyExtension,
    atfActions,
    setToolbar,
    prepareFileName,
    getFileNameWithoutExt,
    getFileExt,
    isInArrayKey,
    encodeUtf8,
    decodeUtf8,
    isEmpty,
    changeApostrophe,
    removeInvalidFileChar,
    verifyExistFile,
    formatFormDataRequest,
    allowConvert,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { ConfirmationService } from 'primeng/api';
import { EditorService } from '@service/editor.service';
import { VariableListService } from '@service/variablelist.service';
import { lastValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ext_Calc, ext_Images, ext_Pdf, ext_Text, extGed, extPdf } from '@documalis/_const/const';
import { DownloadService } from '@service/download.service';

@Component({
    selector: 'attachedfile',
    templateUrl: 'attachedfile.component.html',
    styleUrls: ['attachedfile.component.scss'],
    providers: [HttpClientUploadService],
})
export class AttachedFileComponent {
    @Input() public editMode = true;
    @Input() public listAtf;
    @Input() public scroll = false;
    @Input() public isLock = false;
    @Input() public docId;
    @Input() public docName;
    @Input() public atfActions: atfActions;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();
    @Output()
    public onUpdateAtf: EventEmitter<any> = new EventEmitter();
    @Output()
    public onClickAtfGed: EventEmitter<any> = new EventEmitter();

    public itemConfirm: ItemConfirmComponent;
    public displayUpload = false;
    public uploadCountSuccess = 0;
    public uploadCountError = 0;
    public sendingCount = 0;
    public cancelAdd = false;
    public visible: boolean;
    public error = false;
    public errorMessage = '';
    public displayRename = false;
    public displayStop: boolean = false;
    public atfName = '';
    private oldAtfName = '';
    private atfExt = '';
    public ctrlDouble = [];
    private listFile = [];
    private listFileSuccess = [];
    private listFileError = [];
    public listComboPrefix: any[];

    public showThumbPdf: boolean;
    public showThumbImg: boolean;
    public thumbs: any;
    public thumbName: string;
    public showThumb: boolean = false;

    @ViewChild('uploadForm') uploadForm;
    options: DropTargetOptions = {
        color: 'dropZoneColor',
        colorDrag: 'dropZoneColorDrag',
        colorDrop: 'dropZoneColorDrop',
        multiple: true,
    };

    constructor(
        protected _messageService: MessagesService,
        public editorService: EditorService,
        public variableListService: VariableListService,
        public uploader: HttpClientUploadService,
        private api: ApiV6Service,
        public confirmationService: ConfirmationService,
        private translate: TranslateService,
        private downloadService: DownloadService
    ) {
        this.listComboPrefix = new Array();
    }

    public ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.initUpLoader();
        this.resetListFile();
        this.getRenameProperties();
    }

    public ngOnChanges() {}

    public initUpLoader() {
        this.uploader.queue = [];
        this.uploader.removeAllFromQueue();
        this.resetCounter();
        this.cancelAdd = false;

        this.uploader.onCancel$.subscribe((data: FileItem) => {
            console.log('file deleted: ' + data.file.name, data.isSuccess);
        });

        this.uploader.onProgress$.subscribe((data: any) => {
            if (data.progress === 100) {
                this.sendingCount++;
            }
        });

        this.uploader.onSuccess$.subscribe((data: any) => {
            this.uploadCountSuccess++;
            this.updateFileList(this.listFileSuccess, data.body.FileName);
            this.onUpdateAtf.emit({
                atfFile: {
                    name: data.body.FileName,
                    size: data.item.file.size,
                },
                action: 'add',
                info: {
                    listFileSuccess: this.listFileSuccess.length,
                    listFileError: this.listFileError.length,
                    listFile: this.listFile.length,
                    cancelAdd: this.cancelAdd,
                    uploadCountSuccess: this.uploadCountSuccess,
                },
            });
            if (
                this.listFileSuccess.length + this.listFileError.length === this.listFile.length &&
                this.cancelAdd === false &&
                this.uploadCountSuccess !== 0
            ) {
                this.displayUpload = false;
            }
        });

        this.uploader.onError$.subscribe((data: any) => {
            console.log('file error: ' + data.item.file.name);
            this.updateFileList(this.listFileError, data.item.file.name);
            this.uploadCountError++;
            this._messageService.addErrorMsg(this.translate.instant('Send_On_KO') + data.item.file.name);
        });

        this.uploader.onAddToQueue$.subscribe((data: any) => {
            this.prepareUpload(data);
        });
    }

    public closeAddfile() {
        this.uploader.queue.map((item, index) => {
            item.remove();
        });
        this.uploader.removeAllFromQueue();
        this.uploader.queue = [];
        this.uploadForm.reset();
        this.resetCounter();
        this.cancelAdd = false;
        this.displayUpload = false;
        this.displayStop = false;
        this.resetListFile();
    }

    private resetListFile() {
        this.listFile = [];
        this.listFileSuccess = [];
        this.listFileError = [];
        this.ctrlDouble = [];
    }

    private getRenameProperties() {
        let wComboProp: any;
        this.listComboPrefix = [];
        if (this.atfActions.atfAllowPrefixList === true && this.atfActions.atfRenaming !== '') {
            wComboProp = this.variableListService.getOptionComboValue(this.atfActions.atfRenaming);
            if (wComboProp !== undefined) {
                this.listComboPrefix.push({
                    name: this.atfActions.atfRenaming,
                    Label: this.translate.instant('Atf_Typ'),
                    valdefault: '',
                    type: wComboProp.type,
                    comboValue: wComboProp.option,
                    system: false,
                    DefaultValue: '',
                    Editable: false,
                    pattern: '',
                    disabled: false,
                    ReadOnly: false,
                });
            }
        }
    }

    private updateFileList(aListFile, aFileName) {
        const index = aListFile.indexOf(aFileName);
        if (index === -1) {
            aListFile.push(aFileName);
        }
    }

    public cancelAddfile() {
        this.cancelAdd = true;
        let wNbAdd = this.uploadCountSuccess;
        let wNbErr = this.uploadCountError;
        let wSend = this.sendingCount;
        this.close(null);
        if (wNbErr === 0) {
            this._messageService.addWarn(this.translate.instant('File_Stop', {nbFile: wSend}));
        } else {
            if (wSend - wNbErr !== 0) {
                this._messageService.addWarn(this.translate.instant('File_Stop', {nbFile: (wSend - wNbErr)}));
            }
        }
    }

    private async prepareUpload(aData) {
        // Ne pas changer l'ordre des 3 lignes
        let wRes = false;
        wRes = verifySizeDownLoad(this.uploader, this._messageService, this.translate);
        if (wRes === false) {
            return;
        }
        wRes = verifyExtension(this.uploader, this._messageService, null, this.translate);
        if (wRes === false) {
            return;
        }        
        this.ctrlDouble = verifyExistFile(this.uploader, aData, this.ctrlDouble);
        if (this.uploader.queue.length !== 0) {
            this.updateFileList(this.listFile, aData.file.name);
            setToolbar();
            this.uploadForm.reset();
            this.resetCounter();
            this.displayUpload = true;
            this.visible = true;
        }
    }

    private resetCounter() {
        this.uploader.progressTotal = 0;
        this.uploadCountSuccess = 0;
        this.uploadCountError = 0;
        this.sendingCount = 0;
    }

    public close(event) {
        this.closeAddfile();
        this.displayUpload = false;
    }

    public removeItem(aItemFile) {
        this.listFile = this.listFile.filter((item) => {
            return item.toLowerCase() !== aItemFile.file.name.toLowerCase();
        });
        this.ctrlDouble = this.ctrlDouble.filter((item) => {
            return item.name.toLowerCase() !== aItemFile.file.name.toLowerCase()
        })
        aItemFile.remove();
        this.uploadForm.reset();
        if (this.uploader.queue.length === 0) {
            this.close(null);
        }
    }


    public onClickAdd(event) {
        this.displayStop = true;
        this.uploader.queue.map((item, index) => {
            this.addDataToFile(item, this.docId);
        });
        this.uploader.uploadAll({
            method: 'POST',
            url: this.api.execGetUrlGedAction('addattachedfile', ''),
        });
    }

    public onClickStop(event) {
        this.uploader.cancelAll();
        this.cancelAdd = true;
        let wNbErr = this.uploadCountError;
        let wSend = this.sendingCount;
        this.close(null);
        if (wNbErr === 0) {
            this._messageService.addWarn(this.translate.instant('File_Atf_Stop', {nbFile: wSend}));
        } else {
            if (wSend - wNbErr !== 0) {
                this._messageService.addWarn(this.translate.instant('File_Atf_Stop', {nbFile: (wSend - wNbErr)}));
            }
        }
    }

    private addDataToFile(item: FileItem, aDocID) {
        let wRequest;
        let wFileName = item.file.name;
        wFileName = prepareFileName(wFileName, 64, true);
        wRequest = {
            Docid: aDocID,
            AtfName: wFileName,
        };
        item.formData = formatFormDataRequest(wRequest);
    }

    private verifyAtfExist(aFileName, aListFile) {
        let wFileName: string;
        let wFile = getFileNameWithoutExt(aFileName);
        let wNoExt = wFile;
        let wExt = getFileExt(aFileName);
        let i = 2;
        while (isInArrayKey(wNoExt + wExt, aListFile, 'Name') !== undefined) {
            wNoExt = wFile + '(' + i + ')';
            i++;
        }
        wFileName = wNoExt + wExt;
        return wFileName;
    }

    public async downloadAtfFile(event) {
        this.downloadService.setDocId(this.docId);
        await this.downloadService.downloadAtfFile(event.name, false);
    }

    public removeAtfFile(event) {
        setToolbar();
        this.itemConfirm.confirmAction(
            'deleteatf',
            this.translate.instant('Atf_Del', {name: event.name}),
            () => {
                this.delete(event.name);
            }
        );
    }
    
    public transAtfFileBsk(event) {
        let wRequest = {
            Docid: this.docId,
            AtfName: encodeUtf8(event.name),
        };
        this.onUpdateAtf.emit({
            data: wRequest,
            action: 'trs',
        });
    }

    public convertAtfFile(event) {
        setToolbar();
        this.itemConfirm.confirmAction(
            'convertatf',
            this.translate.instant('Atf_Cnv', {name: event.name}),
            () => {
                this.convert(event.name);
            }
        );
    }

    public convert(aAtfName) {
        this.execAtfAction('cnvattachedfile', '', aAtfName, '');
    }

    public delete(aAtfName) {
        this.execAtfAction('delattachedfile', '', aAtfName, '');
    }

    public renameAtfFile(event) {
        setToolbar();
        this.displayRename = true;
        this.atfName = getFileNameWithoutExt(event.name);
        this.oldAtfName = this.atfName;
        this.atfExt = getFileExt(event.name);
    }

    public closeRename() {
        this.displayRename = false;
    }

    public onClickRenameAtf() {
        this.atfName = this.atfName.trimStart();
        if (this.verfiyRename() === false) {
            return;
        }
        if (this.atfName !== this.oldAtfName) {
            this.execAtfAction('renattachedfile', this.oldAtfName, this.atfName, this.atfExt);
        }
        this.displayRename = false;
    }

    private verfiyRename() {
        let wValue: string;
        let wIndex = -1;
        if (isEmpty(this.atfName)) {
            this._messageService.addWarnNoStick(this.translate.instant('File_Empty'));
            return false;
        }
        if (this.atfActions.atfAllowPrefixList === true && this.atfActions.atfRenaming !== '') {
            wValue = this.editorService.getValueFromType(this.listComboPrefix[0], true);
            if (isEmpty(wValue)) {
                this._messageService.addWarnNoStick(this.translate.instant('Atf_Ext'));
                return false;
            }
            this.atfName = wValue + '_' + this.atfName;
        }
        this.atfName = changeApostrophe(removeInvalidFileChar(this.atfName.normalize('NFC')));
        wIndex = this.listAtf.findIndex((item) => {
            return item.Name === this.atfName + this.atfExt;
        });
        if (wIndex !== -1) {
            this._messageService.addErrorNoStick(this.translate.instant('Ren_Atf'));
            return false;
        }
        return true;
    }

    private async execAtfAction(aAction, oldAtfName, aAtfName, atfExt) {
        let wRes: any;
        let wRequest;
        let wfilename = aAtfName;
        let wLibAction: string;
        let wFailedMsg: string;

        if (aAction === 'cnvattachedfile') {
            this.oldAtfName = wfilename;
            wRequest = {
                Docid: this.docId,
                AtfName: encodeUtf8(wfilename),
            };
            wLibAction = this.translate.instant('Conv_End');
            wFailedMsg = this.translate.instant('Convert_KO');
        }
        if (aAction === 'delattachedfile') {
            wRequest = {
                Docid: this.docId,
                AtfName: encodeUtf8(aAtfName),
            };
            wLibAction = this.translate.instant('Del_ActEnd');
            wFailedMsg = this.translate.instant('Delete_KO');
        }
        if (aAction === 'renattachedfile') {
            wRequest = {
                Docid: this.docId,
                AtfOriName: encodeUtf8(oldAtfName + atfExt),
                AtfNewName: encodeUtf8(aAtfName + atfExt),
            };
            wLibAction = this.translate.instant('Ren_End');
            wFailedMsg = this.translate.instant('Ren_KO');
        }

        const formData = formatFormDataRequest(wRequest);
        try {
            wRes = await lastValueFrom(this.api.execUrlAction(aAction, formData));
        } catch (error) {
            this._messageService.addErrorMsg(wFailedMsg);
            return;
        }
        
        this._messageService.addSuccess(wLibAction);
        if (aAction === 'cnvattachedfile') {
            this.onUpdateAtf.emit({
                oldAtfName: this.oldAtfName,
                name: decodeUtf8(wRes.AtfNewName),
                action: 'cnv',
            });
        }
        if (aAction === 'delattachedfile') {
            this.onUpdateAtf.emit({
                name: decodeUtf8(wRes.FileName),
                action: 'del',
            });
        }
        if (aAction === 'renattachedfile') {
            this.onUpdateAtf.emit({
                oldAtfName: decodeUtf8(wRequest.AtfOriName),
                name: decodeUtf8(wRes.AtfNewName),
                action: 'ren',
            });
        }
    }

    public async Show_PJ(atfFile: any) {
        if (atfFile.Extension.toLowerCase() === extGed) {       
            this.onClickAtfGed.emit(atfFile);
        } else {
            await this.execDownLoad(atfFile);
        }
    }

    private async execDownLoad(atfFile: any) {
        let wUrl = '';
        let wListVisu = [...ext_Pdf, ...ext_Text, ...ext_Calc];
        this.showThumb = false;
        this.showThumbPdf = false;
        this.showThumbImg = false;
        this.downloadService.setDocId(this.docId);        
        await this.downloadService.downloadAtfFile(atfFile.Name, true);
        wUrl = this.downloadService.getUrl();
        if (allowConvert(atfFile.Extension.toLowerCase(), wListVisu) === true) {
            this.showThumbPdf = true;
        } else {
            this.showThumbImg = true;
        }
        this.thumbName = atfFile.Name;
        this.thumbs = wUrl;
        this.showThumb = true;
    }
}
